import { LitElement, html, css } from 'lit-all'

class NovaCardVideo extends LitElement {
  static properties = {
    videoObject: {
      type: Object,
      attribute: 'video-object',
    },
    autoplay: {
      type: Boolean,
    },
    loop: {
      type: Boolean,
    },
    description: {
      type: String,
    },
  }

  get videoElement() {
    return this.renderRoot?.querySelector('video') ?? null
  }

  constructor() {
    super()
    this._handleMouseover = this._handleMouseover.bind(this)
    this._handleMouseout = this._handleMouseout.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.style.setProperty(
      '--nova-aspect-ratio',
      this.videoObject?.aspect_ratio
    )
    if (!this.autoplay) {
      this.addEventListener('mouseover', this._handleMouseover)
      this.addEventListener('mouseout', this._handleMouseout)
    }
  }

  _handleMouseover() {
    this.videoElement.play()
  }

  _handleMouseout() {
    this.videoElement.pause()
  }

  disconnectedCallback() {
    if (!this.autoplay) {
      this.removeEventListener('mouseover', this._handleMouseover)
      this.removeEventListener('mouseout', this._handleMouseout)
    }
  }

  render() {
    return html`
      <div class="test"></div>
      <video
        playsinline="playsinline"
        ?autoplay="${this.autoplay}"
        ?loop="${this.loop}"
        ${this.posterImage ? `poster="${this.posterImage}"` : html``}
        preload="none"
        muted="muted"
        aria-label="${this.description}"
        poster="${this.videoObject.poster_image}"
      >
        ${this.videoObject.sources.map(
          (source) =>
            html`<source src="${source.url}" type="${source.mime_type}"></source>`
        )}
      </video>
    `
  }

  static styles = css`
    :host {
      aspect-ratio: var(--nova-aspect-ratio, 16 / 9);
      display: block;
      position: relative;
    }
    video {
      background: black;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  `
}

window.customElements.define('nova-card-video', NovaCardVideo)